module.exports = __webpack_public_path__ + "images/8cad4f78d4d9a810326b1cdb6b8d28b8-DJRY5575a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/home/DJRY5575a.jpg
// module id = ./src/assets/images/slides/home/DJRY5575a.jpg
// module chunks = 0